Vue.component('adminMedals', {
  template: templates.adminMedals,
  data() {
    return {
      model: {
        edit: false,
        medal: {
          id: null,
          name: null,
          description: null,
          active: false
        },
        medals: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      medalService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.image = `/images/medals/${d.id}.png`;
            d.video = `/videos/medals/${d.id}.webm`;
            data[`${d.id}`] = d;
          }
          c.model.medals = data;
          c.$root.$emit('getMedals', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.medals[`${id}`];

      if (id == c.model.medal.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.medal = {
        id: id,
        name: data.name,
        description: data.description,
        active: data.active
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.medal;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (!data.description) {
        utils.alert.error('Description is required');
        return;
      }
      
      medalService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.medals[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.medals[`${data.id}`] = data;
          }

          c.reset();
          
          utils.alert.success('Saved!');
          
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    upload() {
      const c = this;

      let data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      data.append('type', 'medals');
      data.append('id', c.model.medal.id);

      uploadService.uploadFile(data)
        .then(function (response) {
          utils.alert.success('File uploaded!');
        })
        .catch(function (error) {
          utils.alert.error('File failed to uploaded.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      
      c.model.medal = {
        id: null,
        name: null,
        description: null,
        active: false
      }
    }
  }
});